<template>
  <div class="content-box">
    <el-image src="/static/imgs/swhz.png" fit="cover" class="w-img saveimg" />

    <div class="w1200 w-box">
      <div class="isleft">
        <div v-for="(item,index) in box" :key="index" :class="tap == index ? 'defga':''" @click="tapClick(index)">
          {{item.name}}
        </div>
      </div>
      <div class="isright">
        <div class="gys">
          {{obj.title}}
        </div>
        <div class="qttxt">
          <div v-html="obj.content"></div>
        </div>
      </div>
    </div>

    <div class="p-web">
      <div class="w92">
        <div class="dis p-mgi">
          <div v-for="(item,index) in box" :key="index" :class="tap == index ? 'defga kks':'kks'" @click="tapClick(index)">
            {{item.name[0]}}{{item.name[1]}}<br />
            {{item.name[2]}}{{item.name[3]}}
          </div>
        </div>

        <div class="panting" v-if="box.length">
          <div class="panting-tit">{{box[tap].name}}</div>
        </div>

        <div v-html="obj.content"></div>

      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        box: [],
        tap: 0,
        obj: {}
      }
    },
    mounted() {
      this.getData()

    },
    methods: {
      getData() {
        this.$request('get', this.$otapi + 'items/cooperation_types?filter={"status":"published"}', {}, (res) => {
          if (res.status == 200) {
            this.box = res.data.data
            this.getDataDert(res.data.data[0].id)
          }
        })
      },
      tapClick(i) {
        this.tap = i
        this.getDataDert(this.box[i].id)
      },
      getDataDert(id) {
        this.$request('get', this.$otapi + 'items/cooperations?filter={"category":'+id+'}', {}, (res) => {
          if (res.status == 200) {
            this.obj = res.data.data[0]
          }
        })
      }
    },
    metaInfo() {
      return {
        title: '聚木网-加入我们'
      }
    }
  }
</script>

<style scoped>
  .w1200 {
    margin: 88px auto 70px auto;
    display: flex;
    justify-content: space-between;
  }

  .isleft {
    width: 292px;
    background: #F4F4F4;
  }

  .isleft div {
    width: 100%;
    height: 64px;
    line-height: 64px;
    text-align: center;
    color: #37393F;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    transition: all .8s;
  }

  .isbg {
    background: #6B78E5;
    color: #fff !important;
    font-size: 20px !important;
    font-weight: bold;
  }

  .isright {
    width: 860px;
  }

  .gys {
    font-size: 32px;
    font-weight: bold;
    color: #37393F;
    padding-bottom: 10px;
    border-bottom: 2px solid #B9B9B9;

  }

  .qttxt {
    font-size: 14px;
    color: #000;
    font-weight: 400;
    line-height: 22px;
    margin: 13px 0;
  }

  .defga {
    background: #6B78E5 !important;
    color: #fff !important;
  }

  .p-mgi {
    margin: 1.25rem 0;
  }
  .kks{
    padding: 0.58rem 1.8rem;
    font-size: 1.4rem;
    color: #37393F;

    background: #F7F7FF;
  }
  .panting {
    padding: 0.4rem 0.66rem;
    width: 8rem;
    color: #6B78E5;
    font-size: 1.4rem;
    font-weight: bold;
    background: #F1F1FD;
    margin: 1.25rem 0 1rem 0;
  }

  .panting-tit {
    padding-left: 0.66rem;
    border-left: 1px solid #6B78E5;
  }

  .p-web{
    padding-bottom: 6rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/cooperate.vue